// extracted by mini-css-extract-plugin
module.exports = {"section":"Documents_section__CImA0","header":"Documents_header__3Ei-C","fileUpload":"Documents_fileUpload__3QHV9"};